import initModal from "./initializers/Modal.js";
import initUser from "./initializers/User.js";
import initCustomFieldType from "./initializers/CustomFieldType.js";

const initApplication = () => {
  initModal();
  initUser();
  initCustomFieldType();
};

export default initApplication;
